// modal/detail/panels/PermissionsPanel.jsx
import React from 'react';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import Chip from '@mui/material/Chip';
import Divider from '@mui/material/Divider';

import { SoftCard } from 'shared/ui/soft/SoftCard';
import { PillIcon } from 'shared/ui/soft/PillIcon';
import { PermissionToggleRow } from '../ui/PermissionToggleRow';

// ✅ merkezi schema
import { PERMS_SCHEMA, groupPerms } from 'sectors/pilates/staff/permission/permsSchema';
function countEnabled(perms) {
  return Object.values(perms || {}).filter(Boolean).length;
}

function countTotalFromGrouped(grouped) {
  let n = 0;
  Object.values(grouped).forEach((rows) =>
    rows.forEach((row) => {
      n += (row.scopes || []).length;
    })
  );
  return n;
}

export function PermissionsPanel({ active, localPerms, onTogglePerm }) {
  const grouped = React.useMemo(() => groupPerms(PERMS_SCHEMA), [PERMS_SCHEMA]);
  const enabledCount = React.useMemo(() => countEnabled(localPerms), [localPerms]);
  const totalCount = React.useMemo(() => countTotalFromGrouped(grouped), [grouped]);

  if (!active) return null;
  return (
    <div style={{ display: active ? 'block' : 'none' }}>
      <SoftCard>
        <MDBox display="flex" alignItems="center" justifyContent="space-between" sx={{ mb: 1.25 }}>
          <MDBox display="flex" alignItems="center" gap={1}>
            <PillIcon icon="shield" tone="teal" />
            <MDBox>
              <MDTypography variant="h6" fontWeight="bold" sx={{ lineHeight: 1.1 }}>
                Yetkiler
              </MDTypography>
              <MDTypography variant="caption" sx={{ color: 'text.secondary' }}>
                Kategorili On/Off — açıklamalı
              </MDTypography>
            </MDBox>
          </MDBox>

          <Chip
            size="small"
            label={`${enabledCount}/${totalCount} açık`}
            variant="outlined"
            sx={{ borderRadius: '999px', fontWeight: 800 }}
          />
        </MDBox>

        <MDBox sx={{ display: 'grid', gap: 1.1 }}>
          {Object.entries(grouped).map(([groupName, rows]) => (
            <MDBox
              key={groupName}
              sx={(theme) => ({
                border: `1px solid ${theme.palette.divider}`,
                borderRadius: 2,
                overflow: 'hidden',
              })}
            >
              <MDBox sx={{ px: 1.5, py: 1, bgcolor: 'rgba(0,0,0,.02)' }}>
                <MDTypography variant="caption" fontWeight="bold" sx={{ opacity: 0.85 }}>
                  {groupName}
                </MDTypography>
              </MDBox>

              <Divider />

              <MDBox sx={{ p: 1.25, display: 'grid', gap: 1 }}>
                {rows.map((row) => (
                  <MDBox key={row.baseKey} sx={{ display: 'grid', gap: 0.5 }}>
                    <MDTypography variant="caption" fontWeight="bold" sx={{ opacity: 0.9 }}>
                      {row.label}
                    </MDTypography>

                    <MDBox sx={{ display: 'grid', gap: 0.7 }}>
                      {(row.scopes || []).map((s) => {
                        const enabled = Boolean(localPerms?.[s.key]);
                        return (
                          <PermissionToggleRow
                            key={s.key}
                            label={s.label}
                            description={s.description}
                            enabled={enabled}
                            onToggle={(nextVal) => onTogglePerm(s.key, nextVal)}
                          />
                        );
                      })}
                    </MDBox>
                  </MDBox>
                ))}
              </MDBox>
            </MDBox>
          ))}
        </MDBox>

        <MDTypography variant="caption" sx={{ color: 'text.secondary', mt: 1 }}>
          (Not) Backend bağlanınca: audit log üretilecek.
        </MDTypography>
      </SoftCard>
    </div>
  );
}
